import React, {useState, useRef, useEffect} from "react";
import assets from "../assets/imgs";
import HeaderExtra from "./HeaderExtra";
import Pagination from "./Pagination";

import CommuteChangeBox from "./CommuteChangeBox";
import CommuteTimeEditModal from "./CommuteTimeEditModal";
import ManageItemModal from "./ManageItemModal";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import config from "../config/config";

const API_URL = config.API_URL;

function ManagerCommuteStaticsCalendar({style, commuteData, currentDate,
  handlePrevMonth, handleNextMonth, userTable, onDataUpdate, authority}){

  const [selectedCommuteInfo , setSelectedCommuteInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태
  // const [filteredData, setFilteredData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const filterColumn = userTable ? "account" : "startup_id";

  // const [currentDate, setCurrentDate] = useState(new Date());
  const dummyDate = new Date(currentDate);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTimeEditModalOpen, setIsTimeEditModalOpen] = useState(false);
  const [selectedTimeEdit, setSelectedTimeEdit] = useState(null);
  const [isManageModalOpen, setIsManageModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [selectedCompany, setSelectedCompany] = useState(null);
  const getMonthAllDates = (year, month) => {
    const daysInMonth = new Date(year, month + 1, 0).getDate(); // 이번 달의 마지막 날짜
    const allDates = [];
    
    for (let day = 1; day <= daysInMonth; day++) {
      const formattedDate = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
      allDates.push(formattedDate);
    }
    return allDates;
  };

  const itemsPerPage = 15; // 페이지당 항목 수
  const startIndex = (currentPage - 1) * itemsPerPage;
  const items = commuteData.slice(startIndex, startIndex + itemsPerPage);
  useEffect(() => {
    // console.log('table on');
    if(commuteData && commuteData.length > 0){
      // Initialize total pages when component mounts
      setTotalPages(Math.ceil(commuteData.length / itemsPerPage));
    }
  }, [commuteData]);

  const onSelectCompany = (key) =>{
    setSelectedCompany(key);
  }

  const handleDownload = () => {
    const excelData = [];

    // 첫 줄: 헤더
    const header = [userTable ? "성함" : "업체명", `${String(dummyDate.getFullYear()).slice(2)}/${String(dummyDate.getMonth() + 1).padStart(2, "0")} 출근현황`];
    for (let i = 1; i <= 30; i++) {
      header.push(`${i}일`);
    }
    excelData.push(header);

    // 팀명 정규화 함수 (㈜, (주), 주식회사, 공백 제거)
    const normalizeName = (name) => {
      return name
        .replace(/㈜|주식회사|\(주\)|\s/g, '')
        .replace(/\(OCIAL\)/g, '')
        .toLowerCase();
    };

    // 순번 매핑 테이블 (하드코딩)
    const teamOrderMap = {
      "오스": 1, "엘엠엑스": 2, "마이크로메디옴": 3, "악어에듀": 4,
      "피카부랩스": 5, "컨시언스파트너스": 6, "나와": 7, "파이큐랩": 8,
      "더키퍼": 9, "스밈팩토리": 10, "포스트얼라인": 11, "마인드풀랩스": 12,
      "스페이스점프": 13, "폰드메이커스": 14, "고로켓컴퍼니": 15, "스텔업": 16,
      "섬루션": 17, "아이앤그로쓰": 18, "휴스파인": 19, "유니폭스": 20,
      "한국정보통신과학기술": 21, "케이에이치에스이": 22, "헤이트먼데이": 23, "페블즈": 24,
      "헬로프렌즈": 25, "세이브프롬": 26, "퐁": 27, "axoneq": 28,
      "에임즈미디어": 29, "언박싱드림즈": 30, "biofrix": 31, "오르빗코리아": 32,
      "퍼슬리": 33, "테르밋": 34, "오셜": 35, "기계공화국": 36,
      "메디하이브": 37, "k-healthmatch": 38, "데일리컴파운드": 39, "cognileap": 40,
      "lococo": 41, "컬러루트": 42, "피어링": 43, "만동제과": 44,
      "조앤안": 45, "어치바": 46, "seedwave": 47, "루이스타": 48,
      "ruistar": 48, "워터리아": 49, "씨플립": 50
    };

    // commuteData를 순번에 맞춰 정렬
    const sortedData = [...commuteData].sort((a, b) => {
      const normalizedA = normalizeName(a.name);
      const normalizedB = normalizeName(b.name);

      const orderA = teamOrderMap[normalizedA] || 999;
      const orderB = teamOrderMap[normalizedB] || 999;

      // 순번이 같으면 이름 가나다순
      if (orderA === orderB) {
        return a.name.localeCompare(b.name);
      }

      return orderA - orderB;
    });

    // 데이터 변환
    sortedData.forEach((item) => {
      const row = [];
      row.push(item.name);

      const count = item.commute.filter((c) => c.check === 1).length;
      row.push(`${count}/30`);

      item.commute.forEach((entry) => {
        if (entry.check === 1) {
          // 출근한 경우: 시간 정보 표시
          let cellValue = "";
          if (entry.checkIn) {
            cellValue += `출 ${entry.checkIn.time}`;
            if (entry.checkIn.isOutside) cellValue += " (외)";
          }
          if (entry.checkOut) {
            if (cellValue) cellValue += "\n";
            cellValue += `퇴 ${entry.checkOut.time}`;
            if (entry.checkOut.isOutside) cellValue += " (외)";
          }
          row.push(cellValue || "O");
        } else {
          row.push("X");
        }
      });

      excelData.push(row);
    });

    // 워크시트 생성
    const worksheet = XLSX.utils.aoa_to_sheet(excelData);

    // 워크북 생성
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `출근현황`);

    // 엑셀 파일로 저장
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(fileData, `${String(dummyDate.getFullYear()).slice(2)}/${String(dummyDate.getMonth() + 1).padStart(2, "0")} 출근현황.xlsx`);
  };

  const openManageModal = (item) => {
    setSelectedItem(item);
    setIsManageModalOpen(true);
  };

  // const handleCommuteChange = () =>{
  //   setIsModalOpen(true);
  // }
  const openModal = ({selData = {}}) => {
    setSelectedCommuteInfo(selData);
    console.log(selData);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  
  // const handlePrevMonth = () => {
  //   const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
  //   setCurrentDate(prevMonth);
  // };

  // const handleNextMonth = () => {
  //   const nextMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
  //   setCurrentDate(nextMonth);
  // };
  
  const year = dummyDate.getFullYear();
  const month = dummyDate.getMonth();
  const dates = getMonthAllDates(year, month);

  const getDayOfWeek = (dateStr) => {
    const days = ["일", "월", "화", "수", "목", "금", "토"];
    const date = new Date(dateStr);
    return days[date.getDay()];
  };

  // console.log('item', items);

  const companyMap = items.map(company => ({
    key: company[filterColumn],
    label: company.name,
  }));
  // console.log(companyMap);
  
  return (
    <div className="commonComponent" style={{...style, padding: "20px", margin: "16px", paddingBottom: "50px", position: "relative"}}>
      {/* 상단 네비게이션 */}
      <div style={styles.calendarHead}>
        <CompanyFilterButton companies={companyMap} selectedCompany={selectedCompany} onSelectCompany={onSelectCompany}
          searchable={companyMap.length >= 10} userTable={userTable}/>
        <div style={styles.calendarHeadCenter}>
          <button style={styles.calendarHeadButton} onClick={handlePrevMonth}>
            <assets.icons.chevron_left style={{ color: "var(--grayscale-cool_100)"}}/>
          </button>
          <div style={styles.titleSection}>
            <img src={assets.icons.calendar} style={{width: "20px"}}/>
            <p style={styles.calendarTitle}>{year}.{String(month + 1).padStart(2, "0")}</p>
          </div>
          <button style={styles.calendarHeadButton} onClick={handleNextMonth}>
            <assets.icons.chevron_right style={{ color: "var(--grayscale-cool_100)"}}/>
          </button>
        </div>
        <div style={styles.calenderHeadButtonSection}>
          {!userTable && <HeaderExtra.WriteExtra onRed={true} onClick={openModal} text ={'출근 통계 변경'}/>}
          <HeaderExtra.WriteExtra onRed={false} onClick={handleDownload} text={'엑셀 다운로드'} />       
        </div>
        
      </div>
      {/* 요일 */}
      <div style={styles.tableContainer} className="tableContainer">
        <table style={styles.table}>
          {/* 테이블 헤더 */}
          <thead>
            <tr>
              <th style={styles.stickyColumn} className="font-body4-semibold">{userTable ? '성함' : '업체명'}</th>
              <th style={styles.stickyColumn2} className="font-body4-semibold">이번달 출근일수</th>
              {dates.map((date) => (
                <th key={date} style={styles.tableHeader}>
                  <div style={styles.tableHeaderContent}>
                    <div style={styles.tableHeaderContentTop} className="font-body5-semibold">{getDayOfWeek(date)}</div>
                    <div style={styles.tableHeaderContentBottom} className="font-body4-semibold">{Number(date.split("-")[2])}</div>
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          {/* 테이블 본문 */}
          <tbody>
            {items
            .filter((company) => selectedCompany === null || company[filterColumn] === selectedCompany)
            .map((company) => {
              const totalCommutes = company.commute.filter(
                (entry) => entry.check === 1
              ).length;
              return (
                <tr key={company[filterColumn]}>
                  <td
                    style={{
                      ...styles.stickyColumn,
                      cursor: (authority === 6 || authority === 7) ? "pointer" : "default",
                      textDecoration: (authority === 6 || authority === 7) ? "underline" : "none",
                    }}
                    className="font-body4-regular"
                    onClick={() => {
                      if (authority === 6 || authority === 7) {
                        openManageModal(company);
                      }
                    }}
                  >
                    {company.name}
                  </td>
                  <td style={{...styles.stickyColumn2, backgroundColor: "var(--grayscale_20)"}} className="font-body4-regular">
                    {totalCommutes}/{dates.length}
                  </td>
                  {dates.map((date) => {
                    const entry = company.commute.find((e) => e.date === date);
                    return (
                      <td key={date} style={{...styles.tableCell,
                        cursor: (userTable && (authority === 6 || authority === 7)) || !userTable ? "pointer" : "default"}}
                        className="font-body4-regular"
                        onClick={(e) => {
                          if(userTable){
                            // userTable인 경우: 권한 6,7이면 출근 기록 유무와 관계없이 시간 수정 모달 열기
                            if(authority === 6 || authority === 7){
                              console.log('Opening edit modal - date:', date, 'userName:', company.name, 'userId:', company.user_id, 'entry:', entry);
                              setSelectedTimeEdit({
                                date: date,
                                userName: company.name,
                                userId: company.user_id,
                                initialData: {
                                  checkIn: entry?.checkIn || null,
                                  checkOut: entry?.checkOut || null
                                }
                              });
                              setIsTimeEditModalOpen(true);
                            }
                            return;
                          }
                          // 기존 로직 (startup table)
                          if(new Date() < new Date(date)){
                            alert('지난 날짜만 변경할수 있습니다.');
                            return;
                          }
                          const dummyData = {
                            startup_id : company.startup_id,
                            date : date,
                            commute: (entry.check === 1 ? "출근" : "결근")
                          };
                          openModal({selData: dummyData});
                        }}>
                        {entry ? (
                          entry.check === 1 ? (
                            // 시간 정보가 있으면 시간 표시, 없으면 "O"
                            (entry.checkIn || entry.checkOut) ? (
                              <div style={styles.timeCellContainer}>
                                {entry.checkIn && (
                                  <div style={styles.timeRow}>
                                    <span style={styles.timeLabel}>출</span>
                                    <span style={styles.timeValue}>{entry.checkIn.time}</span>
                                    {entry.checkIn.isOutside && <span style={styles.outsideBadge}>외</span>}
                                  </div>
                                )}
                                {entry.checkOut && (
                                  <div style={styles.timeRow}>
                                    <span style={styles.timeLabel}>퇴</span>
                                    <span style={styles.timeValue}>{entry.checkOut.time}</span>
                                    {entry.checkOut.isOutside && <span style={styles.outsideBadge}>외</span>}
                                  </div>
                                )}
                              </div>
                            ) : "O"
                          ) : "X"
                        ) : "-"}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>        
      </div>
      <Pagination 
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        style= {{position: "absolute",
          bottom: "12px",
          left: "50%",
          transform: "translateX(-50%)",}}
      />
      
      {isModalOpen && (
        <CommuteChangeBox onClose={closeModal} selectedData={selectedCommuteInfo}/>
      )}

      {/* 시간 수정 모달 */}
      {isTimeEditModalOpen && selectedTimeEdit && (
        <CommuteTimeEditModal
          date={selectedTimeEdit.date}
          userName={selectedTimeEdit.userName}
          userId={selectedTimeEdit.userId}
          initialData={selectedTimeEdit.initialData}
          onClose={() => {
            setIsTimeEditModalOpen(false);
            setSelectedTimeEdit(null);
          }}
          onUpdate={onDataUpdate}
        />
      )}

      {/* 사용자/팀 관리 모달 */}
      {isManageModalOpen && selectedItem && (
        <ManageItemModal
          item={selectedItem}
          userTable={userTable}
          onClose={() => {
            setIsManageModalOpen(false);
            setSelectedItem(null);
          }}
          onUpdate={onDataUpdate}
          allStartups={commuteData}
        />
      )}
    </div>
  );
}


function CompanyFilterButton({onSelectCompany, companies, selectedCompany, searchable = false, userTable = false}){
  //selected는는 key로 전달한다.
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const buttonRef = useRef();
  const popupRef = useRef(); // Ref for the popup container
  const inputRef = useRef(null);

  const filteredCompanies = companies.filter(item =>
    item.label.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const filterTargetText = userTable ? '유저' : '기업';
  const filterInputPlaceHolder = `${filterTargetText}명을 입력해주세요`;

  // console.log('filter 쪽입니다.', companies);
  
  const togglePopup = () => {
    if(searchable){
      if(isPopupVisible){
        return null;
      }else{
        setTimeout(() => {
          inputRef.current?.focus();
        }, 0); // popup 열린 뒤에 실행되게
      }
    }
    setPopupVisible(!isPopupVisible);
  };

  const handleSelect = (key) => {
    
    onSelectCompany(key);
    setPopupVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popupRef.current && 
        !popupRef.current.contains(event.target) && 
        !buttonRef.current.contains(event.target)
      ) {
        setPopupVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const selected = (selectedCompany !== null);

  return (
    <div style={{ position: "relative" }}>
      <button ref={buttonRef} onClick={togglePopup} style={{
        ...styles.filterButton, 
        borderColor: selected ? "var(--main-blue_50)": "var(--grayscale-cool_50)"}}
        >
        {(isPopupVisible && searchable) ? (
          <input
            ref={inputRef}
            className="font-body4-semibold"
            style={{backgroundColor: '#fff', border: "none", outline: "none" }}
            type="text"
            placeholder={filterInputPlaceHolder}
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setPopupVisible(true);
            }}
            onFocus={() => setPopupVisible(true)}
            onBlur={() => setTimeout(() => setPopupVisible(false), 150)} // blur 시 살짝 딜레이
          />
        ):(
          <p className="font-body4-semibold" style={{color: selected ? "var(--main-blue_60" : "var(--text-color_50)" }}>
            {selected ? (`${filterTargetText}별 :` +  findLabelByKey(companies, selectedCompany)) : `${filterTargetText}별`}
          </p>
        )}
        <assets.icons.sort style={{color: selected ? "var(--main-blue_60)" : "var(--grayscale_60)"}}/>
        {/* <img src={selected ? assets.icons.calendar_selected : assets.icons.calendar} 
        style={{width: "16px"}}/> */}
      </button>
      {isPopupVisible && (
        <div ref={popupRef} style={styles.filterBox}>
          <ul style={styles.categoryList}>
            {filteredCompanies.map((company) => (
              <li
                key={company.key}
                onClick={() => handleSelect(company.key)}
                style={{
                  ...styles.filterItem,
                  color:
                    selectedCompany === company.key
                      ? "var(--main-blue_60)"
                      : "var(--text-color_50)",
                  fontWeight:
                    selectedCompany === company.key ? "bold" : "normal",
                }}
              >
                <p className="font-body2-semibold" style={{
                  flex: "1",
                  color : (selectedCompany === company.key) ? "var(--text-color_70)" : "var(--text-color_50)"
                }}>{company.label}</p>
                {(selectedCompany === company.key) ? 
                  <assets.icons.check style={{color: "var(--main-blue_50)"}}/> 
                  : null}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}



const findLabelByKey = (companies, key) => {
  const found = companies.find((item) => item.key === key);
  return found ? found.label : null; // 값이 없으면 null 반환
};



const filterButton = {
  border: "1px solid var(--grayscale-cool_50)",
  borderRadius: "4px",
  height: "45px",
  display:"flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  padding:"8px 16px",
  backgroundColor: "white",
  cursor: "pointer",
}

const filterBox ={
  position: "absolute",
  boxSizing: "border-box",
  top: "calc(100% + 10px)",
  left: 0,
  background: "white",
  border: "1px solid #ddd",
  borderRadius: "8px",
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
  zIndex: 1000,
}

const styles ={
  calendarHead:{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "22px 0px",
    // height: "51px",
    boxSizing: "border-box",
    height: "72px",
    borderBottom: "1px solid var(--grayscale-cool_20)",
    marginBottom: "24px",
    position: "relative",
  },
  calendarHeadCenter:{
    display: "flex",
    // flex: "1",
    justifyContent: "center",
    alignItems: "center",
    gap: "44px",
    // height: "51px",
    boxSizing: "border-box",
  },
  titleSection:{
    display: "flex",
    alignItems: "center",
    gap: "20px",
  },
  calendarTitle:{
    fontWeight: "600",
    fontSize: "18px",
    lineHeight:"27px",
    color: "var(--text-color_90)",
    borderRadius: "20px 20px 0px 0px",
  },  
  calendarHeadButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    border: "1px solid var(--grayscale-cool_40)",
    borderRadius: "8px",
    width: "28px",
    height: "28px",
    backgroundColor: "white",
  },
  calenderHeadButtonSection:{
    display: "flex",
    gap: "12px"
  },
  tableContainer: {
    overflowX: "auto",
    whiteSpace: "nowrap",
    scrollbarWidth: "thin", // Firefox에서 얇은 스크롤바 적용
    scrollbarColor: "var(--primary-crimson_30) var(--grayscale_30)", // Firefox 스크롤바 색상 설정
  },
  table: {
    borderCollapse: "collapse",
    width: "max-content",
    minWidth: "600px",
  },
  stickyColumn: {
    position: "sticky",
    maxWidth: "120px",
    width : "120px",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    padding: "0px 10px",
    left: 0,
    boxSizing: "border-box",
    background: "var(--grayscale_30)",
    // border: "1px solid #ddd",
    // padding: "8px",
    textAlign: "center",
    zIndex: 2,
  },
  stickyColumn2: {
    position: "sticky",
    width: "100px",
    left: "120px",
    background: "var(--grayscale_30)",
    // border: "1px solid #ddd",
    // padding: "8px",
    textAlign: "center",
    zIndex: 2,
  },
  tableHeader: {
    // border: "1px solid #ddd",
    textAlign: "center",
    background: "var(--grayscale_30)",
    boxSizing: "border-box",
    width: "68px",
  },
  tableHeaderContent: {
    display: "flex",
    flexDirection: "column", // 요소를 세로로 정렬
    alignItems: "center",
  },
  tableHeaderContentTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "23px",
    width: "100%",
    borderBottom: "1px solid var(--grayscale_40)"
  },
  tableHeaderContentBottom: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "30px",
  },
  // companyCell: {
  //   position: "sticky",
  //   left: 0,
  //   background: "#fff",
  //   border: "1px solid #ddd",
  //   padding: "8px",
  //   textAlign: "left",
  //   fontWeight: "bold",
  //   zIndex: 1,
  // },
  // commuteCountCell: {
  //   position: "sticky",
  //   left: "100px",
  //   background: "#fff",
  //   border: "1px solid #ddd",
  //   padding: "8px",
  //   textAlign: "center",
  //   zIndex: 1,
  // },
  tableCell: {
    borderBottom: "1px solid var(--grayscale-cool_20)",
    padding: "8px",
    textAlign: "center",
    width: "68px",
    boxSizing: "border-box",
    minHeight: "40px"
  },
  timeCellContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    alignItems: "center",
  },
  timeRow: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "10px",
  },
  timeLabel: {
    fontWeight: "600",
    color: "#666",
  },
  timeValue: {
    fontWeight: "500",
    color: "#232323",
  },
  outsideBadge: {
    fontSize: "8px",
    color: "#FF8A00",
    backgroundColor: "#FFF4E6",
    padding: "2px 4px",
    borderRadius: "3px",
    fontWeight: "600",
  },

  //CompanyFilter BUtton

  filterButton:{
    ...filterButton,
  },
  filterBox:{
    ...filterBox,
  },
  filterItem:{
    minWidth: "102px",
    padding: "16px 20px 16px 16px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    borderBottom: "1px solid var(--grayscale-cool_20)",
    cursor: "pointer",
  },
}

// /* 웹킷(Chrome, Edge, Safari) 전용 스크롤바 스타일 */
// const tableContainerScrollbarStyles = `
//   .tableContainer::-webkit-scrollbar {
//     height: 6px; /* 가로 스크롤바 높이 */
//   }

//   .tableContainer::-webkit-scrollbar-thumb {
//     background-color: var(--primary-crimson_30); /* 스크롤바 색상 */
//     border-radius: 4px; /* 둥근 모서리 */
//   }

//   .tableContainer::-webkit-scrollbar-track {
//     background-color: var(--grayscale_30); /* 트랙 배경색 */
//   }
//   .tableContainer::-webkit-scrollbar-button {
//     display: none; /* 스크롤바 화살표 숨기기 */
//   }
// `;


// /* 스타일을 동적으로 추가 */
// const styleElement = document.createElement("style");
// styleElement.innerHTML = tableContainerScrollbarStyles;
// document.head.appendChild(styleElement);

export default ManagerCommuteStaticsCalendar;